import type { RowVariantDefinition } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { defineRowVariantRegistry } from '@/deskUiSkeletons/rowTemplates/RowVariantRegistry'
import { sharedChatAnswerVariant } from '@/msgComponents/rowVariants/Chat/Chat'
import { productRowVariantForPath, productRowVariantsForPath } from '../../../productDisplayCatalog'
import { Gallery2CommentTemplate } from './variants/Gallery2Comment'
import { Gallery2SlideTemplate } from './variants/Gallery2Slide'

const commentVariant = {
  ...productRowVariantForPath('gallery2', 2),
  Template: Gallery2CommentTemplate,
} as const satisfies RowVariantDefinition

const slideVariant = {
  ...productRowVariantForPath('gallery2', 3),
  Template: Gallery2SlideTemplate,
} as const satisfies RowVariantDefinition

const productRows = productRowVariantsForPath('gallery2')

export const rowVariantRegistry = defineRowVariantRegistry({
  answers: {
    variants: [commentVariant, slideVariant, sharedChatAnswerVariant],
    fallback: productRows.answers.fallback,
  },
  submsges: {
    variants: [commentVariant, slideVariant],
    fallback: productRows.submsges.fallback,
  },
})
